import { WHITE_SPACE } from 'constants/editors';
import { REQUIRED_SYMBOL } from 'constants/general';

const getRequiredSymbol = (required: boolean | undefined) => (required ? `${WHITE_SPACE}${REQUIRED_SYMBOL}` : '');

export default getRequiredSymbol;